import { render, staticRenderFns } from "./CloudDashboard.vue?vue&type=template&id=4a7f0c70&scoped=true&"
import script from "./CloudDashboard.vue?vue&type=script&lang=js&"
export * from "./CloudDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CloudDashboard.vue?vue&type=style&index=0&id=4a7f0c70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7f0c70",
  null
  
)

export default component.exports